import * as React from 'react';
import {
  makeStyles,
  FormControl,
  FormLabel,
  FormGroup,
  withStyles,
  TextField,
  TextFieldProps
} from '@material-ui/core';
import { neutral } from '../../../theme/colors';
import { KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';
import { ParsableDate } from '@material-ui/pickers/constants/prop-types';

interface Props {
  /** display name of collection of filters */
  title: string;
  startDate: moment.Moment | null;
  endDate: moment.Moment | null;
  onStartDateChange: (date: moment.Moment | null, value: ParsableDate) => void;
  onEndDateChange: (date: moment.Moment | null, value: ParsableDate) => void;
}

const useStyles = makeStyles({
  formGroup: {
    alignItems: 'flex-start',
    whiteSpace: 'nowrap'
  },
  formLabel: {
    color: neutral[600],
    fontWeight: 500
  },
  input: {
    maxWidth: 150,
    marginTop: 8,
    marginBottom: 8
  }
});

const CustomizedTextField = withStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      fontSize: '14px'
    }
  }
})(TextField);

const SmallTextField = (props: TextFieldProps) => <CustomizedTextField {...props} size="small" variant="outlined" />;

/**
 * Render a section of date filters
 */
const DateFilterGroup = ({ title, startDate, endDate, onStartDateChange, onEndDateChange }: Props) => {
  const classes = useStyles();

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend" className={classes.formLabel}>
        {title}
      </FormLabel>
      <FormGroup className={classes.formGroup}>
        <KeyboardDatePicker
          label="Start Date"
          value={startDate}
          onChange={onStartDateChange}
          format="MM/DD/YYYY"
          variant="inline"
          inputVariant="outlined"
          TextFieldComponent={SmallTextField}
          KeyboardButtonProps={{ size: 'small', edge: 'end' }}
          className={classes.input}
        />
        <KeyboardDatePicker
          label="End Date"
          value={endDate}
          onChange={onEndDateChange}
          format="MM/DD/YYYY"
          variant="inline"
          inputVariant="outlined"
          TextFieldComponent={SmallTextField}
          KeyboardButtonProps={{ size: 'small', edge: 'end' }}
          className={classes.input}
        />
      </FormGroup>
    </FormControl>
  );
};

export default DateFilterGroup;
